<small class="debug"> {{ me }} </small>
<div *ngIf="lockMode ; else nonLockMode" class="mainTwoFactorPad">
    <mat-label class="shadowedTextBold">
        {{ 'general.authenticator' | transloco }}
    </mat-label>
    <br/>
    <br/>
    <mat-label>
        {{ 'general.enterAuth' | transloco }}
    </mat-label>
    <br/>
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
        <mat-form-field *ngFor="let control of inputControls; let i = index" class="example-form-field">
            <input matInput
                   maxlength="1"
                   type="text"
                   inputrestriction="numbers"
                   pattern="[0-9]*"
                   (input)="onInput($event, i)"
                   (keydown.backspace)="onBackspace($event, i)"
                   #inputBox
                   class="input-box"
                   [(ngModel)]="inputValues[i]" style="font-size: 1.5em">
        </mat-form-field>

        <!-- Clear button -->
        <button mat-icon-button (click)="clearInputs()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <div style="text-align: center">
        <div mat-dialog-actions style="justify-content: center;">
            <button color="warn" [disabled]="!inputValuesReady" (click)="checkTwoFactor()" mat-raised-button>
                Authenticate
            </button>
        </div>
        <br/>
    </div>
</div>


<ng-template let-modal #twoFactorModalEnable>
    <br/>
    <div style="padding: 10px">
        <mat-label>
            {{ 'general.disableTwoFactor' | transloco }}
        </mat-label>
        <br/>
        <br/>
        <mat-label>
            {{ 'general.enterAuth' | transloco }}
        </mat-label>
        <br/>

        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
            <mat-form-field *ngFor="let control of inputControls; let i = index" class="example-form-field">
                <input matInput
                       maxlength="1"
                       type="text"
                       inputrestriction="numbers"
                       pattern="[0-9]*"
                       (input)="onInput($event, i)"
                       (keydown.backspace)="onBackspace($event, i)"
                       #inputBox
                       class="input-box"
                       [(ngModel)]="inputValues[i]" style="font-size: 1.5em">
            </mat-form-field>
            <button mat-icon-button (click)="clearInputs()">
                <mat-icon>clear</mat-icon>
            </button>
        </div>
        <br/>
        <div style="text-align: center">
            <div mat-dialog-actions style="justify-content: center;">
                <button color="warn" [disabled]="!inputValuesReady" (click)="disableTwoFactor()" mat-raised-button>
                    <mat-icon>block</mat-icon>
                    {{ 'general.remove' | transloco }}
                </button>
            </div>
            <br/>
        </div>
    </div>
</ng-template>

<ng-template let-modal #twoFactorModalDisable>
    <br/>
    <div style="text-align: center">
        <mat-label class="shadowedTextBold">
            {{ 'general.enableAuth' | transloco }}
        </mat-label>
        <br/>
        <br/>
        <img [src]="twoFactorQrCode">
        <br/>
        <br/>
        <br/>
        <mat-label style="padding: 10px">
            Scan with google Authenticator and enter the code below
        </mat-label>
        <br/>
        <br/>
        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
            <mat-form-field *ngFor="let control of inputControls; let i = index" class="example-form-field">
                <input matInput
                       maxlength="1"
                       type="text"
                       inputrestriction="numbers"
                       pattern="[0-9]*"
                       (input)="onInput($event, i)"
                       (keydown.backspace)="onBackspace($event, i)"
                       #inputBox
                       class="input-box"
                       [(ngModel)]="inputValues[i]" style="font-size: 1.5em">
            </mat-form-field>
            <button mat-icon-button (click)="clearInputs()">
                <mat-icon>clear</mat-icon>
            </button>
        </div>
        <br/>
        <div style="text-align: center">
            <div mat-dialog-actions style="justify-content: center;">
                <button (click)="onClose()" mat-raised-button>
                    <mat-icon>close</mat-icon>
                    {{ 'general.cancel' | transloco }}
                </button>
                <button color="warn" [disabled]="!inputValuesReady" (click)="enableTwoFactor()" mat-raised-button>
                    <mat-icon>check</mat-icon>
                    {{ 'general.enable' | transloco }}
                </button>
            </div>
            <br/>
        </div>
        <br/>
    </div>
</ng-template>


<ng-template #nonLockMode>
    <div style="padding-top: 20px; padding-bottom: 20px; padding-left: 0">
        <h2 class="form-signin-heading"></h2>
        @if (m_twoFactorState) {
            <button mat-raised-button color="warn" type="submit" (click)="onTwoFactorAuthentication()" class="sub">
                {{ 'account.twoFactoAuth' | transloco }}
                <mat-icon style="position: absolute; right: 10px; color: green">check</mat-icon>
            </button>
        } @else {
            <button mat-stroked-button color="primary" type="submit" (click)="onTwoFactorAuthentication()" class="sub">
                {{ 'account.twoFactoAuth' | transloco }}
                <mat-icon style="position: absolute; right: 10px">key</mat-icon>
            </button>
        }
    </div>
</ng-template>
